import dynamic from 'next/dynamic';

export default function withoutSSR(Component: React.ComponentType): React.ComponentType {
  return dynamic(() => Promise.resolve(Component), {
    ssr: false,
  });
}
